export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/580abca75fa1b7d64059a8f5a61a7cf0d3f0eb8d/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"